package one.healthium.insights.domain.models

data class TipsConfigModel(
    val backgroundColor: Long?,
    val textColor: Long?,
)
